import React from 'react';
import isUndefindedOrNull from '../../Common/utils/isUndefinedOrNull';

const Breadcrumbs = (props) => {
    const { content } = props;
    const result = isUndefindedOrNull(content)
    if (result) {
        return null;
    }
    return <ul className="seoBreadcrumb">
        {content.map((obj, index) => {
            const { url, title } = obj;
            if (url) {


                return (<li key={url + title + index} >
                    <span >
                        <a href={url}>
                            <div> {title}</div>

                        </a>
                    </span>
                </li>)
            } else {

                return (<li key={title + index} className="seoBreadcrumbActive">
                    <span>
                        {title}
                    </span>
                </li>)
            }
        })}
    </ul>

}
export default Breadcrumbs;
